import i18next from 'i18next';
import * as Yup from 'yup';
import { VALID_SITE_URL } from '@studio/constants/sites';

type _FormValidationParams = {
  isEdit?: boolean;
};

const useSiteFormValidation = (params: _FormValidationParams = { isEdit: false }) => {
  const { isEdit } = params;

  const urlRequired = () => {
    if (!isEdit) {
      return Yup.string()
        .required(i18next.t('pages:sites.fields.url.required'))
        .matches(VALID_SITE_URL, i18next.t('pages:sites.fields.url.characters'));
    } else {
      return Yup.string();
    }
  };

  return Yup.object({
    url: urlRequired(),
    googleAnalyticsId: Yup.string().test(
      'url-format',
      i18next.t('pages:sites.fields.googleAnalyticsId.format'),
      (value) => {
        if (value) {
          const validUrlBasic = /^(G)-[a-zA-Z0-9-]+$/;
          return validUrlBasic.test(value);
        }
        return true;
      }
    ),
    isUrlAvailable: Yup.bool().oneOf([true], i18next.t('pages:sites.fields.url.unavailable')),
    name: Yup.string().required(i18next.t('pages:sites.fields.name.required')),
  });
};

export default useSiteFormValidation;
